<p-sidebar [(visible)]="visible" [position]="sidebarPosition" [style]="{ width: width }" (onHide)="closeSidebar()">

  <ng-template pTemplate="header">
    <span class="filter-header">{{ title | translate }}</span>
  </ng-template>

  <div class="filter-wrapper">
    <div class="filter-content">
      @if (fields.length) {
      <form [formGroup]="form" (ngSubmit)="onApply()">
        <formly-form [fields]="fields" [model]="model" [form]="form" [options]="formOptions"
          (modelChange)="onModelChange($event)">
        </formly-form>
      </form>
      } @else {
      <div class="no-fields-message">
        <p>{{ 'FILTER.NO_FILTER_FIELDS' | translate }}</p>
      </div>
      }
    </div>

    @if (showApplyButton || showClearButton) {
    <div class="filter-actions">
      @if (showApplyButton) {
      <button type="button" class="btn btn-solid-main" (click)="onApply()" [disabled]="!form.valid">
        {{ applyButtonText | translate }}
      </button>
      }

      @if (showClearButton) {
      <button type="button" class="btn btn-outline-main" (click)="onClear()">
        {{ clearButtonText | translate }}
      </button>
      }
    </div>
    }
  </div>
</p-sidebar>